import { useRef, useEffect } from 'react'

export const Checkbox = ({ checked, partChecked = undefined, onChange, readOnly }) => {

  return (
    <label className="relative inline-grid size-4 place-items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={readOnly}
        className="peer h-4 w-4 cursor-pointer appearance-none rounded
                   border border-zinc-200 bg-white
                   checked:bg-primary-600 checked:border-primary-600
                   focus-visible:outline-2 focus-visible:outline-offset-2
                   focus-visible:outline-primary-600
                   disabled:opacity-20
                   forced-colors:appearance-auto"
      />

      {partChecked ? (
        <svg
          viewBox="0 0 14 14"
          fill="none"
          className="absolute size-3.5 stroke-white pointer-events-none"
        >
          <path
            d="M3 7H11"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          viewBox="0 0 14 14"
          fill="none"
          className="absolute size-3.5 stroke-white pointer-events-none"
        >
          <path
            d="M3 8L6 11L11 3.5"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

    </label>
  );
};